var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHealth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    width: "100px",
    height: "100px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface221606557"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(40.000001%,40.000001%,40.000001%)",
      fillOpacity: 1
    },
    d: "M 72 7.980469 L 28 7.980469 C 16.972656 7.980469 8 16.953125 8 27.980469 L 8 71.980469 C 8 83.007812 16.972656 91.980469 28 91.980469 L 72 91.980469 C 83.027344 91.980469 92 83.007812 92 71.980469 L 92 27.980469 C 92 16.953125 83.027344 7.980469 72 7.980469 Z M 59.984375 55.765625 C 59.375 56.078125 58.625 56.078125 58.015625 55.765625 C 46.527344 49.882812 40 40.628906 40 32.308594 C 40 22.738281 50.519531 19.117188 57.542969 25.617188 C 58.367188 26.382812 59.628906 26.382812 60.457031 25.617188 C 67.480469 19.117188 78 22.738281 78 32.308594 C 78 40.628906 71.472656 49.882812 59.984375 55.765625 Z M 59.984375 55.765625 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.79efbb90a7dae427e516e0b35182559e.svg";
export { ForwardRef as ReactComponent };